export default "__VITE_ASSET__26149c03__"